module.exports = __webpack_public_path__ + "img/p4.2e799dd9.png";